import { render, staticRenderFns } from "./FundDividends.vue?vue&type=template&id=a9331d04"
import script from "./FundDividends.vue?vue&type=script&lang=js"
export * from "./FundDividends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports